import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

interface Ctx {
  emitenteId: number | null;
  setEmitenteId: (id: number | null) => void;
}

const EmitenteAtivoContext = createContext<Ctx | null>(null);
const STORAGE_KEY = 'emitenteAtivo';

export function EmitenteAtivoProvider({ children }: { children: ReactNode }) {
  const [emitenteId, setEmitenteIdState] = useState<number | null>(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    return v ? Number(v) : null;
  });

  useEffect(() => {
    if (emitenteId == null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, String(emitenteId));
  }, [emitenteId]);

  return (
    <EmitenteAtivoContext.Provider value={{ emitenteId, setEmitenteId: setEmitenteIdState }}>
      {children}
    </EmitenteAtivoContext.Provider>
  );
}

export function useEmitenteAtivo() {
  const ctx = useContext(EmitenteAtivoContext);
  if (!ctx) throw new Error('useEmitenteAtivo deve estar dentro de EmitenteAtivoProvider');
  return ctx;
}
